var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.66667C0 1.95942 0.280951 1.28115 0.781048 0.781048C1.28115 0.280951 1.95942 0 2.66667 0H7.04C7.31973 0.000212391 7.5923 0.088395 7.81914 0.252067C8.04598 0.415738 8.21561 0.646608 8.304 0.912L10.3013 6.90267C10.4025 7.20712 10.3906 7.53785 10.2676 7.83419C10.1447 8.13053 9.919 8.37261 9.632 8.516L6.62267 10.0227C8.09776 13.2874 10.7126 15.9022 13.9773 17.3773L15.484 14.368C15.6274 14.081 15.8695 13.8553 16.1658 13.7324C16.4621 13.6094 16.7929 13.5975 17.0973 13.6987L23.088 15.696C23.3536 15.7845 23.5846 15.9543 23.7483 16.1814C23.912 16.4085 24.0001 16.6814 24 16.9613V21.3333C24 22.0406 23.719 22.7189 23.219 23.219C22.7189 23.719 22.0406 24 21.3333 24H20C8.95467 24 0 15.0453 0 4V2.66667Z",
    fill: "#0051CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.cdae336fb5fc3a0ad6e88125118d09c1.svg";
export { ForwardRef as ReactComponent };